import { Tooltip } from '@mui/material'
import { NotificationsActive, NotificationsNone } from '@mui/icons-material'
import { PrometheusAlert, RuuviTag } from '../types'
import BlinkingComponent from './BlinkingComponent'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import { AlertSeverity } from '../enums'

interface RuuviTagAlertIndicatorProps {
  /**
   * The ruuviTag.
   */
  ruuviTag: RuuviTag

  /**
   * The alerts.
   */
  alerts: PrometheusAlert[]

  /**
   * Indicates if alerts are being loaded.
   */
  loading?: boolean

  /**
   * The font size.
   */
  fontSize?: 'inherit' | 'small' | 'medium' | 'large'
}

/**
 * An alert indicator for RuuviTag.
 */
export default function RuuviTagAlertIndicator({
  ruuviTag,
  alerts,
  fontSize = 'inherit'
}: RuuviTagAlertIndicatorProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * The navigate function.
   */
  const navigate = useNavigate()

  const iconColor = useMemo(
    () => (alerts.some((a) => a.labels.severity === AlertSeverity.CRITICAL) ? 'error' : 'warning'),
    [alerts]
  )

  return (
    <>
      {alerts.length > 0 ? (
        <Tooltip title={t('deviceHasActiveAlerts')}>
          <BlinkingComponent>
            <NotificationsActive
              fontSize={fontSize}
              color={iconColor}
              sx={{ cursor: 'pointer' }}
              onClick={() => navigate(`/ruuvi-tags/${ruuviTag.id}/alerts`)}
            />
          </BlinkingComponent>
        </Tooltip>
      ) : (
        <Tooltip title={t('noAlerts') as string}>
          <NotificationsNone fontSize={fontSize} color="disabled" />
        </Tooltip>
      )}
    </>
  )
}
